<div class="row productLabelFormPage">
  <div class="mainContent">

    <div class="row">
      <div class="header w-100">
        <h3 class="mx-3 mt-3">Reservation Details</h3>
      </div>
    </div>
    <div class="OrderReleaseTop seedReserveCreate">

      <div class="row align-items-start mt-2">
        <div class="col-md-3 material-select withBordr productLabelAccountName">
          <ng-select name="ddlShipTo"
                     [items]="shipToData"
                     class="custom-select-grower grower-add-drop"
                     [virtualScroll]="true"
                     bindValue="accountNumber"
                     placeholder="Account:"
                     [(ngModel)]="formdata.accountNumber"
                     [loading]="shipToDataLoading"
                     (change)="onAccountInputChange($event)"
                     [closeOnSelect]="true"
                     data-testid="ddl-ship-to-search"
                     [disabled]="readOnlyAccess"
                     [searchFn]="accountSearchFn"
                     [ngClass]="{'no-border': formdata.accountNumber}">

            <!-- Custom selected label -->
            <ng-template ng-label-tmp let-item="item">
              <div class="selected-template">
                <p class="greenColor m-0">{{ item.accountName }}</p>
                {{ item.address1 }}, {{ item.city }}, {{ item.state }} - {{ item.zipCode }}<br />
                {{ item.primaryPhoneNumber }}<br />
                Account #: {{ item.accountNumber }}
              </div>
            </ng-template>

            <!-- Dropdown option template stays the same -->
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-shipto-return-option_'+index">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="name greenColor" [ngOptionHighlight]="search">
                      {{item.accountName}}
                    </h4>
                    <p class="address m-0" [ngOptionHighlight]="search">
                      {{item.address1}}, {{item.city}}, {{item.state}} - {{item.zipCode}}
                    </p>
                    <p class="phoneNo m-0" [ngOptionHighlight]="search">
                      {{item.primaryPhoneNumber}}
                    </p>
                    <p class="grower-nos m-0">
                      <span class="grower-gln" [ngOptionHighlight]="search">
                        Account #: {{item.accountNumber}}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-md-3 my-3 my-md-0 salesRepresentativeColumn material-select withBordr productLabelAccountName">
          <ng-select name="ddlSalesRepresentative"
                     [items]="sellerData"
                     class="custom-select-grower grower-add-drop"
                     [virtualScroll]="true"
                     bindValue="sellerAccountNumber"
                     placeholder="Seller:"
                     [(ngModel)]="formdata.sellerAccountNumber"
                     [loading]="sellerDataLoading"
                     (change)="onSellerSelection($event)"
                     [closeOnSelect]="true"
                     [disabled]="readOnlyAccess"
                     [searchFn]="sellerSearchFn"
                     data-testid="ddl-ship-to-search"
                     [ngClass]="{'no-border': formdata.sellerAccountNumber}">

            <!-- Custom selected label -->
            <ng-template ng-label-tmp let-item="item">
              <div class="selected-template">
                <p class="greenColor m-0">{{ item.sellerAccountName }}</p>
                {{ item.sellerPrimaryPhoneNumber }}<br />
                {{ item.sellerEmailAddress }}
              </div>
            </ng-template>

            <!-- Dropdown options -->
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-shipto-return-option_'+index">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="name greenColor m-0" [ngOptionHighlight]="search">
                      {{ item.sellerAccountName }}
                    </h4>
                    <p class="phoneNo m-0" [ngOptionHighlight]="search">
                      {{ item.sellerPrimaryPhoneNumber }}
                    </p>
                    <p class="grower-nos m-0">
                      <span class="grower-gln" [ngOptionHighlight]="search">
                        Account #: {{ item.sellerAccountNumber }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>

          </ng-select>
        </div>
        <div class="col-md-3 material-select withBordr productLabelAccountName">
          <ng-select name="ddlGrowerDetails"
                     [items]="growerList"
                     class="custom-select-grower grower-add-drop"
                     [virtualScroll]="true"
                     bindValue="gmk"
                     placeholder="Grower:"
                     [(ngModel)]="formdata.gmk"
                     [loading]="growerLoading"
                     (change)="onGrowerSelection($event)"
                     [closeOnSelect]="true"
                     data-testid="ddl-ship-to-search"
                     [disabled]="readOnlyAccess"
                     [searchFn]="growerSearchFn">

            <!-- Custom selected label -->
            <ng-template ng-label-tmp let-item="item">
              <div class="selected-template">
                <p class="greenColor m-0">{{ item.businessName?.toUpperCase() }}</p>
                <!--{{ item.city?.toUpperCase() }}, {{ item.state?.toUpperCase() }}<br />
      {{ item.primaryPhoneNumber }}<br />
      GMK: {{ item.gmk }} | GLN: {{ item.growerGLN }}-->
              </div>
            </ng-template>

            <!-- Dropdown option template stays the same -->
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-shipto-return-option_'+index">
                <div class="row">
                  <div class="col-md-8">
                    <h4 class="name greenColor" [ngOptionHighlight]="search">
                      {{item.businessName?.toUpperCase()}}
                    </h4>
                    <p class="address m-0" [ngOptionHighlight]="search">
                      {{item.address1?.toUpperCase()}}, {{item.city?.toUpperCase()}}, {{item.state?.toUpperCase()}} -
                      {{item.zip}}
                    </p>
                    <p class="phoneNo m-0" [ngOptionHighlight]="search">
                      {{item.primaryPhoneNumber}}
                    </p>
                    <p class="grower-nos m-0">
                      <span class="grower-gln" [ngOptionHighlight]="search">
                        Grower GMK: {{item.gmk}}
                      </span>
                      <span class="grower-gln" [ngOptionHighlight]="search">
                        Grower GLN: {{item.growerGLN}}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-footer-tmp let-search="searchTerm">
              <div class="custom-drop-footer">
                <div class="row">
                  <div class="col-lg-8">
                    <button mat-raised-button class="btns" color="primary" (click)="openGrowerSliderModel()">Advanced Search</button>
                  </div>
                  <div class="col-lg-4 bold text-left">
                    <!--Results : {{element.growerListCount}}-->
                  </div>
                </div>
              </div>

            </ng-template>
          </ng-select>

          <div class="row mt-3">
            <div class="col-md-12 d-flex seedCreateInput">
              <mat-label class="pr-2 mt-1">Retail Account ID:</mat-label>
              <mat-form-field class="wide100">
                <input matInput type="text" name="account" class="pb-1"
                       [(ngModel)]="formdata.retailAccountID"
                       autocomplete="off">
              </mat-form-field>
            </div>
            <!--<div class="col-md-12 margin-t10">
              <mat-form-field class="wide100">
                <mat-label>Email:</mat-label>
                <input matInput type="text" name="account" class="pb-1"
                       [(ngModel)]="formdata.sellerEmail"
                       autocomplete="off">
              </mat-form-field>
            </div>-->
            <div class="col-md-12 d-flex seedCreateInput">
              <mat-label class="pr-2 mt-1">Email:</mat-label>
              <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
                <input matInput type="text" name="accountEmail" maxlength="100"
                       class="pb-1"
                       [readonly]="readOnlyAccess"
                       [(ngModel)]="formdata.growerEmail"
                       [pattern]="emailPattern"
                       (blur)="validateEmail()"
                       [errorStateMatcher]="matcher">
                <mat-error *ngIf="isNotValid">
                  This is invalid e-mail address(s).
                </mat-error>
              </mat-form-field>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center flex-md-row flex-column-reverse">
    <div class="productsection d-flex align-items-center"
         [ngStyle]="!readOnlyAccess && selectedCount > 0 ? {'visibility': 'visible'} : {'visibility': 'hidden'}">
      <div class="col-md-2 d-flex align-items-center">
        <mat-checkbox #Allcheck class="custom-checkbox select-all-check mt-0"
                      [checked]="dataSource.length > 0 && (selectedCount > 0) && (selectedCount == dataSource.length)"
                      [indeterminate]="dataSource.length > 0 && (selectedCount > 0) && (selectedCount < dataSource.length)"
                      [style.display]="readOnlyAccess ? 'none' : ''" (change)="enableAllCheckBoxes(Allcheck._checked);"
                      matTooltip="Select All Items" [matTooltipPosition]="'above'"
                      data-testid="ddl-select-all-product"></mat-checkbox>

        <div class="product-tools-outer" *ngIf="showTabs">
          <div class="product-tools-tab" appClickOutside (clickOutside)="tabNode=''">

            <div class="tab-bar margin-l15 col-md-10">
              <ul>
                <li (click)="tabNode='delete'" class="seperator" matTooltip="Delete Items from Reservation"
                    [matTooltipPosition]="'above'">
                  <i class="icon-ico-trash"></i>
                </li>
              </ul>
            </div>

            <div class="tab-content">
              <div *ngIf="tabNode==='delete'" class="delete-product">
                <div class="tab-content-heading">
                  Delete Items from Reservation
                </div>
                <div class="tab-content-detail">
                  <p>Are you sure you want to delete <span> {{selectedCount}} </span> selected Items(s)?</p>
                  <div class="btn-area">
                    <button mat-raised-button class="btns normal-large-btn" color="primary"
                            (click)="deleteSelectedItems(true)">
                      Yes
                    </button>
                    <button mat-raised-button class="btns normal-large-btn" color="primary"
                            (click)="deleteSelectedItems(false)">
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="btns addReservation" [disabled]="!formdata.accountNumber || !formdata.sellerAccountNumber || !formdata.gmk" mat-raised-button color="primary" (click)="addReservationRow()">
      Add Reservation
    </button>
   </div>
    <div class="tableOuterContainer">
      <table mat-table [dataSource]="dataSource" class="productTable matTables seedReservationTable">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>  </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox #SingleCheck class="custom-checkbox"
                          [style.display]="'contents'"
                          [disabled]="readOnlyAccess"
                          (change)="enableCheckBoxSingle(SingleCheck._checked)"
                          [(ngModel)]="element.selected"
                          [attr.data-testid]="'ddl-specific-check_'+i"></mat-checkbox>
          </td>
          <td mat-footer-cell *matFooterCellDef> </td>
        </ng-container>

        <ng-container matColumnDef="productLine">
          <th mat-header-cell *matHeaderCellDef> Product Line </th>
          <td mat-cell *matCellDef="let element">
            <!-- If productLineName exists -->
            <p class="d-block d-md-none fontSize mb-2">Product Line</p>

            <span *ngIf="element.productLineName && element.marketingBrandName">
              {{ element.productLineName }}
            </span>

            <!-- If productLineName does NOT exist -->
            <ng-select *ngIf="!element.productLineName"
                       [items]="productList"
                       class="custom-select-grower grower-add-drop productLabelDropdown"
                       [virtualScroll]="true"
                       bindLabel="value"
                       [disabled]="readOnlyAccess"
                       bindValue="id"
                       [placeholder]="element.productLineId ? '' : 'Select Product Line'"
                       [(ngModel)]="element.productLineId"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFn"
                       (change)="onProductOrBrandChange(element, 'productLine')"
                       data-testid="ddl-product-line-search">
            </ng-select>
            <div *ngIf="element.hasProductLineError" class="text-danger large">
              Please select Product Line
            </div>
          </td>

        </ng-container>
        <ng-container matColumnDef="marketingBrand">
          <th mat-header-cell *matHeaderCellDef> Marketing Brand </th>
          <td mat-cell *matCellDef="let element">
            <p class="d-block d-md-none fontSize mb-2">Marketing Brand</p>

            <span *ngIf="element.productLineName && element.marketingBrandName">
              {{ element.marketingBrandName }}
            </span>


            <ng-select *ngIf="!element.marketingBrandName"
                       [items]="element.marketingBrandFilteredList"
                       class="custom-select-grower grower-add-drop productLabelDropdown"
                       [virtualScroll]="true"
                       bindLabel="value"
                       [disabled]="readOnlyAccess || !element.productLineId"
                       bindValue="id"
                       [placeholder]="element.marketingBrandId ? '' : 'Select Marketing Brand'"
                       [(ngModel)]="element.marketingBrandId"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFn"
                       (change)="onProductOrBrandChange(element, 'marketingBrand')"
                       data-testid="ddl-marketing-brand-search">
            </ng-select>
            <div *ngIf="element.hasMarketingBrandError" class="text-danger large">
              Please select Marketing Brand
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="labelQty">
          <th mat-header-cell *matHeaderCellDef> Units </th>
          <td mat-cell *matCellDef="let element">
            <p class="d-block d-md-none fontSize mb-2">Units </p>

            <div *ngIf="!element.hasError">
              <button (click)="geuValueChange('decrease',element);" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + element.productName"> - </button>
              <input [readonly]="readOnlyAccess" type="text" class="geu-txt decimal-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.quantity" maxlength="6" appNumbersOnly [attr.data-testid]="'txt-specific-qty_'+i" />
              <button (click)="geuValueChange('increase',element)" class="plus-minus-btn plusBtn" [attr.data-testid]="'increase-' + element.productName"> + </button>
            </div>
            <div *ngIf="element.hasError" class="text-danger large">
              {{ element.errorMessage }}
            </div>
          </td>

        </ng-container>

        <!--Enter product Name Row-->


        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>

  <div class="SeedFulfillBtnSec">

    <div class="row d-flex align-items-center flex-md-row flex-column-reverse">
      <div class="col-md-8 col-12 p-1 d-flex d-md-block">
        <button mat-raised-button *ngIf="!readOnlyAccess" class="btns mobileView" (click)="saveOrder()"
          [style.display]="'inline-block'" [disabled]="!isFormValid() || readOnlyAccess || isPlaceOrderDisable || hasAnyError()">Submit
          Reservation</button>
        <button mat-raised-button class="btns w140" color="primary"
          (click)="navigateTolandingPage()">Cancel</button>
      </div>
      <div class="col-md-4 col-12 text-md-right text-center mb-md-0 mb-2">
        SEED RESERVATION SELECTED <span class="dataCount">{{dataCount}}</span>
      </div>
    </div>
  </div>
</div>
